import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ModalWrapper = styled(Modal)`
  .modal-dialog {
    max-width: 980px;
  }

  .modal-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;

    .modal-title {
      color: #495057;
      font-weight: 600;
    }
  }

  .modal-body {
    padding: 1.25rem 1.5rem;
  }

  .modal-footer {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    justify-content: space-between;
  }
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 1rem;
  height: 460px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    height: auto;
  }
`;

export const PrinterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
  padding-right: 6px;
  border-right: 1px solid #eff2f5;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    max-height: 120px;
    border-right: 0;
  }
`;

export const PrinterItem = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid ${({ $active }) => ($active ? '#009ef7' : 'transparent')};
  border-radius: 6px;
  background: ${({ $active }) => ($active ? '#e7f3ff' : 'transparent')};
  color: ${({ $active }) => ($active ? '#009ef7' : '#495057')};
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #f1f8ff;
  }
`;

export const Badge = styled.span<{ $changed?: boolean }>`
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  text-align: center;
  color: #fff;
  background: ${({ $changed }) => ($changed ? '#f6a609' : '#a1a5b7')};
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  input {
    flex: 1;
  }
`;

export const Tree = styled.div`
  flex: 1;
  overflow-y: auto;
  border: 1px solid #eff2f5;
  border-radius: 6px;
`;

export const Row = styled.label<{ $checked: boolean; $level: number }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 7px 10px 7px ${({ $level }) => 10 + $level * 22}px;
  border-bottom: 1px solid #f5f8fa;
  font-size: 12px;
  font-weight: ${({ $checked }) => ($checked ? 600 : 400)};
  color: ${({ $checked }) => ($checked ? '#009ef7' : 'inherit')};
  background: ${({ $checked }) => ($checked ? '#e7f3ff' : 'transparent')};
  cursor: pointer;

  input {
    margin: 0;
  }
`;

export const Muted = styled.span`
  font-size: 12px;
  color: #7e8299;
`;
